import ko from 'knockout'
import { StartersListViewModel, type StartersListViewModelParams } from './StartersListViewModel'
import template from './starters.list.tpl.html'

if (!ko.components.isRegistered('starters-list')) {
  ko.components.register('starters-list', {
    viewModel: {
      createViewModel: (params: StartersListViewModelParams) => {
        const viewModel = new StartersListViewModel(params)
        return viewModel
      },
    },
    template,
  })
}
